<template>
  <div class="upload-file-box">
    <div class="upload" :style="`width: ${width}px; height: ${height}px;`">
      <div class="input-box" @click="handleUpload">
        <input ref="upload-input" class="upload-input" type="file" :accept="accept" @change="handleClick">
        <div class="place-box" v-if="fileUrl">
          <el-image :src="fileImg" class="img" fit="contain" />
          <p v-if="fileName" class="file-name">{{ fileName }}</p>
        </div>
        <i v-else-if="loading" class="el-icon-loading avatar-uploader-icon"></i>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </div>
      <div v-if="fileUrl" class="cover-box" :style="`width: ${width}px; height: ${height}px;`">
        <div class="btn-box">
          <i class="iconfont icon-bianji" @click="handleUpload"></i>
          <i class="iconfont icon-shanchu" @click="onDelete"></i>
        </div>
      </div>
    </div>
    <div class="hint" :style="`left: ${width}px;`">
      <div class="text">{{desc}}</div>
    </div>
  </div>
</template>

<script>
import fileImg from '@/assets/common_images/file_img.png'
export default {
  name: "uploadFile",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    uploadUrl: {
      default() {
        return ''
      }
    },
    width: {
      type: Number,
      default() {
        return 150
      }
    },
    height: {
      type: Number,
      default() {
        return 150
      }
    },
    desc: {
      type: String,
      default() {
        return '建议：上传doc、docx、pdf类型的文件'
      }
    },
    accept: {
      type: String,
      default() {
        return '.doc, .docx, .pdf'
      }
    }
  },
  data() {
    return {
      fileImg,
      loading: false,
      fileUrl: null,
      fileName: '',
      fileTypeMap: {
        '.doc': 'application/msword',
        '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.pdf': 'application/pdf',
      }, // 文件拓展名对应MIME类型枚举
    };
  },
  created() {
    if(typeof(this.uploadUrl) != 'object') {
      this.fileUrl = this.uploadUrl
    }
  },
  methods: {
    // 点击上传
    handleUpload() {
      this.$refs['upload-input'].click()
    },

    // 文件上传事件
    handleClick(e) {
      this.loading = true
      const files = e.target.files
      const File = files[0]
      const check = this.beforeUpload(File) // 上传前校验
      if (!File || !check) {
        this.loading = false
        return
      }

      this.fileUrl = File
      this.fileName = File.name || ''
      this.$emit('getUploadFile', File, this.name)
      this.loading = false
    },


    // 上传前校验
    beforeUpload(file) {
      if (!file) {
        return
      }

      let fileType = []
      this.accept.split(', ').forEach(item => {
        fileType.push(this.fileTypeMap[item])
      })

      const checkImg = fileType.indexOf(file.type) > -1
      const checkSize = file.size / 1024 / 1024 < 10;

      if (!checkImg) {
        this.$baseMessage('请上传文件类型文件', 'error');
      }
      if (!checkSize) {
        this.$baseMessage('上传文件大小不能超过 10MB', 'error');
      }
      return checkImg && checkSize;
    },

    // 点击删除按钮
    onDelete() {
      this.fileUrl = null
      this.$refs['upload-input'].value = null
      this.$emit('getUploadFile', '', this.name)
    }

  },
  watch: {
    uploadUrl() {
      if(typeof(this.uploadUrl) != 'object') {
        this.fileUrl = this.uploadUrl
      }
    }
  }
};
</script>

<style lang="scss">
.upload-file-box {
  position: relative;
  display: flex;

  .upload {
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    overflow: hidden;
    position: relative;

    &:hover {
      border-color: $base-color-green;
    }

    .input-box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .upload-input {
        display: none;
        z-index: -9999;
      }

      .place-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img {
          width: 30%;
        }

        .file-name {
          margin: 0;
        }
      }

    }

    .cover-box {
      position: absolute;
      left: 0;
      top: 0;
      background-color: #000;
      opacity: 0;
      display: flex;
      align-items: center;

      &:hover {
        opacity: 0.8;
      }

      .btn-box {
        width: 100%;
        display: flex;
        justify-content: space-evenly;

        .iconfont {
          font-size: 18px;
          color: #fff;
          cursor: pointer;

          &:hover {
            color: #05C8AF;
          }
        }
      }
    }
  }


  .avatar-uploader-icon {
    font-size: 30px;
    font-weight: 700;
    color: #cccccc;
  }

  .hint {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .text {
      line-height: 17px;
      font-size: 12px;
      color: #999999;
      margin-left: 10px;
    }
  }
}
</style>
